import React from 'react';
import { FormControlLabel, Radio, TextField } from '@material-ui/core';
import { $contains, $eq, $sw, $ew, $empty } from '../operators';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { FilterForm, useFilterFormActions } from './filter-form';
import { mergeOverride } from './override-operator';

export const LogoFilters = props => <FilterForm {...props} radioFilters={LogoFilterFormItems} />;

function LogoFilterFormItems({ setRadioFilter, radioValue, column }) {
  const { handleInputClick, form, getRadioValue } = useFilterFormActions(
    radioValue,
    setRadioFilter
  );

  return (
    <>
      <FormControlLabel
        value="s3"
        control={<Radio />}
        label="Available in S3"
        name="$eq"
        inputRef={form.register}
      />
      <FormControlLabel
        value="TMDB"
        control={<Radio />}
        label="Available in TMDB"
        name="$eq"
        inputRef={form.register}
      />

      <FormControlLabel
        value="false"
        control={<Radio />}
        label="Available"
        name="$empty"
        inputRef={form.register}
      />
      <FormControlLabel
        value="true"
        control={<Radio />}
        label="Not Available"
        name="$empty"
        inputRef={form.register}
      />
    </>
  );
}
